import { BellOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Empty, Table } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableHelper } from "../../helpers/TableHelper";
import { translate } from "../../locale";
import DashServices from "../../services/DashServices";
import CellButton from "../Buttons/CellButton";
import SendNotification from "../Modals/SendNotification";

const MedicineRecords = ({ selectedData }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);
  const [showNotification, setShowNotification] = useState(false);

  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          >
            <BellOutlined className="text-black" />
          </Button>
        </div>
      ),
      fixed: "left",
    },
    {
      title: "Apellido",
      dataIndex: "surname",
      key: "surname",
      align: "center",
      render: (_, record) => (
        <CellButton
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
        >
          {record.surname}
        </CellButton>
      ),
      sorter: { multiple: 3 },
      fixed: "left",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (_, record) => (
        <CellButton
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
        >
          {record.name}
        </CellButton>
      ),
      sorter: { multiple: 4 },
    },
    {
      title: "Medicamentos",
      dataIndex: "number_medicines",
      key: "number_medicines",
      align: "center",
      sorter: { multiple: 1 },
    },
    {
      title: "Días inactivo",
      dataIndex: "inactive_days",
      key: "inactive_days",
      align: "center",
      sorter: { multiple: 2 },
    },
  ];

  useEffect(() => {
    if (selectedData) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [selectedData, JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      let response = await DashServices.OutRangeMedicine(
        selectedData.period,
        selectedData.suscription,
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(
          response.data.data.filter(
            (i) => i.number_medicines !== 0 || i.inactive_days
          )
        );
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSendNotification = (user_id) => {
    setSelecteUser(user_id);
    setShowNotification(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
    </>
  );
};

MedicineRecords.propTypes = {
  selectedData: PropTypes.object.isRequired,
};

export default MedicineRecords;
